module.exports = __webpack_public_path__ + "img/tuihuan.94fe0cad.png";